import React, { lazy, Suspense } from "react";
import CampaignAccessPublicShell, {
  isCampaignAccessPath,
} from "./pages/campaigns/CampaignAccessPublicShell";

const AuthenticatedAppEntry = lazy(() => import("./AuthenticatedAppEntry"));

export default function AppEntry() {
  if (
    typeof window !== "undefined" &&
    isCampaignAccessPath(window.location.pathname)
  ) {
    return <CampaignAccessPublicShell />;
  }

  return (
    <Suspense fallback={null}>
      <AuthenticatedAppEntry />
    </Suspense>
  );
}
